import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonsModule } from '@hiptraveler/ui/buttons';

import { DontSellInfoComponent } from './dont-sell-info.component';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  MatCheckboxModule,
  TranslateModule
];

const LIBRARIES = [
  ButtonsModule
];

const COMPONENTS = [
  DontSellInfoComponent
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    DontSellInfoComponent
  ]
})
export class DontSellInfoModule { }
